const staff = [
  { name: 'Dr. Sarah Chen', role: 'Cardiologist', patients: 42, rating: 4.9 },
  { name: 'Dr. Michael Rodriguez', role: 'Pediatrician', patients: 38, rating: 4.8 },
  { name: 'Dr. Emily Johnson', role: 'Neurologist', patients: 35, rating: 4.7 },
  { name: 'Nurse Robert Kim', role: 'Head Nurse', patients: 56, rating: 4.9 },
];

// 10 attractive clinic colors
const COLORS = [
  'bg-rose-500', 'bg-blue-500', 'bg-green-500', 'bg-amber-500', 'bg-purple-500',
  'bg-pink-500', 'bg-cyan-500', 'bg-indigo-500', 'bg-teal-500', 'bg-orange-500',
];

// Extracts the first name's initial after any title
const getInitial = (fullName) => {
  const words = fullName.split(' ');
  for (let i = 0; i < words.length; i++) {
    if (!['Dr.', 'Nurse', 'Mr.', 'Ms.', 'Mrs.'].includes(words[i])) {
      return words[i][0] || '?';
    }
  }
  return '?';
};

// Hash function to assign consistent color
const getColorClass = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
};

export default function StaffPerformanceChart() {
  return (
    <div className="rounded-lg border bg-card bg-white shadow-sm p-4">
      <h2 className="text-xl font-semibold leading-tight mb-2 tracking-tight">Staff Performance</h2>
      <p className="text-sm text-muted-foreground mb-4">Top performing staff members</p>
      <div className="space-y-4">
        {staff.map((s, i) => {
          const initial = getInitial(s.name);
          const bgColor = getColorClass(s.name);
          return (
            <div className="flex justify-between items-center" key={i}>
              <div className="flex items-center gap-2">
                <span className={`h-8 w-8 flex items-center justify-center rounded-full text-white text-sm font-medium ${bgColor}`}>
                  {initial}
                </span>
                <div>
                  <p className="text-sm font-medium">{s.name}</p>
                  <p className="text-xs text-muted-foreground">{s.role}</p>
                </div>
              </div>
              <div className="text-right text-sm">
                <p>{s.patients} patients</p>
                <p className="text-xs text-muted-foreground">Rating: {s.rating}/5</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
